import {useState,useEffect, useContext, createContext} from "react";

const LanguageContext = createContext({});
export const useLanguageContext = () => useContext(LanguageContext);

export default function LanguageContextProvider({ children }) {
    const [language, changeLanguage] = useState(() => {
        return localStorage.getItem("language") || "en";
    });

    useEffect(() => {
        localStorage.setItem("language", language);
    }, [language]);


    return (
        <LanguageContext.Provider value={{ language, changeLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
}
